var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForwardicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#3E3232",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 26C17.7188 26 17.4688 25.9062 17.2812 25.7188C16.875 25.3438 16.875 24.6875 17.2812 24.3125L21.5625 20L17.2812 15.7188C16.875 15.3438 16.875 14.6875 17.2812 14.3125C17.6562 13.9062 18.3125 13.9062 18.6875 14.3125L23.6875 19.3125C24.0938 19.6875 24.0938 20.3438 23.6875 20.7188L18.6875 25.7188C18.5 25.9062 18.25 26 18 26Z",
    fill: "#3E3232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardicon);
export default __webpack_public_path__ + "static/media/forwardicon.127d217f434539e47e4aad4649aa77e0.svg";
export { ForwardRef as ReactComponent };